import { Injectable } from '@angular/core';
import { InMemoryDbService, RequestInfo } from 'angular-in-memory-web-api';
import { ServiceConfiguration } from '../backend-mock-service/services/config';
import { CurationIdentifier } from '@ispm-shared/modules/curation';
import {
  HTTP_METHODS,
  InMemoryBackendMockService
} from '@ispm-client/modules/backend-mock-modules/backend-mock-service/services/in-memory-data.service';
import { map, switchMap } from 'rxjs/operators';
import { HttpClient } from '@ispm-client/modules/core/services/http-client';
import { HttpInterceptorService } from '@ispm/core/services/http-interceptor.service';
import { Observable } from 'rxjs';
import { of } from 'rxjs/observable/of';
import { BP_MODEL_URL } from '@ispm/shared/bpmn/services/config';
const MOCK_BPM = 'assets/ispm/Integration_take_1.bpmn';
import * as _ from 'lodash';

@Injectable()
export class PathwaysBackendMockService {
  private curationIdentifier$: Observable<CurationIdentifier> = of();
  private curationInfo;
  private curationIdentifier: CurationIdentifier;

  constructor(private imdb: InMemoryDbService, private httpIspmServer: HttpClient,  private _httpClient: HttpInterceptorService) {
    (imdb as InMemoryBackendMockService)
      .registerHandler(ServiceConfiguration.getBaseURL('curation'), HTTP_METHODS.POST, this.getCurationItem.bind(this));
    (imdb as InMemoryBackendMockService).registerHandler('entity-tree/progression/', HTTP_METHODS.POST, this.getProgression.bind(this));
    (imdb as InMemoryBackendMockService).registerHandler('entity-tree/progression/', HTTP_METHODS.PUT, this.putProgression.bind(this));
    (imdb as InMemoryBackendMockService).registerHandler('entity-tree/progression/search', HTTP_METHODS.POST, this.postProgressionSearch.bind(this));
    (imdb as InMemoryBackendMockService).registerInitiator(BP_MODEL_URL, this.curationIdentifierFromMockedData.bind(this));
    (imdb as InMemoryBackendMockService)
      .registerHandler(
        '/curation/v1/25814a42-2df0-11e9-99b7-0050568d2176?withRelatedEntities=true',
        HTTP_METHODS.GET,
        this.getCurationItemRelatedEntities.bind(this));
    (imdb as InMemoryBackendMockService)
      .registerHandler(
        '/curation/v1/25814a42-2df0-11e9-99b7-0050568d2176/8a2a10dc-44c4-11e9-ac34-0050568d4a70?kb=DFCI_Curation_KB_Definition&type=pathwaybpmn',
        HTTP_METHODS.GET,
        this.getCurationItemRelatedEntities.bind(this));
    (imdb as InMemoryBackendMockService)
      .registerHandler(
        '/curation/v1/25814a42-2df0-11e9-99b7-0050568d2176/requestedRevision?kb=DFCI_Curation_KB_Definition&type=pathwaybpmn&withRelatedEntities=true',
        HTTP_METHODS.GET,
        this.getCurationItemRelatedEntities.bind(this));
    this.curationInfo = require('../../../assets/ispm/CurationInfo.json');
  }

  private getCurationItemRelatedEntities(reqInfo: RequestInfo) {
    return this.curationInfo;
  }

  private curationIdentifierFromMockedData() {
    this.curationIdentifier$ = this._httpClient.get(MOCK_BPM, null, null, {
      Accept: 'application/xml'
    }, { responseType: 'text'}).pipe(
      switchMap(res => this.httpIspmServer.post(BP_MODEL_URL, { data: res.body})) // ,
      // map(identifier => this.curationIdentifier = identifier)
    );
    this.curationIdentifier$.pipe(
      map(data =>
        this.curationInfo = data));
  }

  private getCurationItem(reqInfo: RequestInfo) {
    if (ServiceConfiguration.shouldMockSpecificURL(BP_MODEL_URL)) {
      if (_.get(reqInfo, 'req.body.content.discipline', null)) {
        return this.curationInfo;
      }
      if (_.get(reqInfo, 'req.body.deployment', null)) {
        const clinicalTrials = { 'Task_1w8icf6': [{ id: 'clinicalTrialA'}, { id: 'clinicalTrialB'}], 'Task_0i1obrl': [{ id: 'clinicalTrialC'}]};
        return clinicalTrials;
      }
    } else {

          this.curationInfo.curationData.content.bpmn.bpmnIdentifier = this.curationIdentifier;
          return this.curationInfo;
    }
  }

  private getProgression(reqInfo: RequestInfo) {
    return [];
  }

  private putProgression(reqInfo: RequestInfo) {
    return [];
  }

  private postProgressionSearch(reqInfo: RequestInfo) {
    return [];
  }
}
